<ng-template #modalcontent>
    @if(!!popup.sections){
    <div [appStoryblok]="get_content(popup._editable)" class="rounded-xl" [ngClass]="backgroundColor">
        @if (popupTitle || popup.closeconfig == 'ALL' || popup.closeconfig == 'CLOSEBUTTON') {
        <div class="modal-header flex flex-row justify-between">
            <div>
                @if (!! popupTitle) {
                <div class="ps-6" [innerHTML]="popupTitle"></div>
                }
            </div>
            @if (popup.closeconfig == 'ALL' || popup.closeconfig == 'CLOSEBUTTON') {
            <button class="closebutton" (click)="popupModal.close()"><i class="bi bi-x-lg"></i></button>
            }
        </div>
        }
        <div class="modal-body">
            @for (section of popup.sections; track $index) {
            <section [appStoryblok]="get_content(section._editable)" [ngClass]="{'mt-[-10px]' : $index === 0}" [id]="!section.anchor ? section._uid : section.anchor">
                <app-cms-section [section]="section" [index]="$index" [inPopup]="true"></app-cms-section>
            </section>
            }
        </div>
    </div>
    }

</ng-template>